import { maskAsPhoneNumber } from './supportFuncs';
import { initParentInfo } from './parentInfo'; // We can share the structural mechanics

export function initEmergContact() {

  // console.log("Emerg Contact initiated");

  const emergRelation = document.getElementById('emergRelation');
  const emergPhone = document.getElementById('emergPhone');
  
  // ACTIVATE DYNAMIC PHONE MASK
  if (emergPhone) maskAsPhoneNumber(emergPhone);
  
  if (emergRelation) {
    emergRelation.addEventListener('change', () => {
      const isOther = emergRelation.value === 'Other';
      const wrapper = document.getElementById('otherEmergencyWrapper');
      const input = document.getElementById('emergRelationOther');
      
      if (!wrapper || !input) return;

      if (isOther) {
        wrapper.classList.remove('d-none');
        input.setAttribute('required', 'required');
      } else {
        wrapper.classList.add('d-none');
        input.removeAttribute('required');
        input.value = '';
      }
    });
  }
}